import { SignApplicationRequest } from '@features/wizard/types/sign.types.ts';

import { adminAxios } from '@/lib/axios.ts';

const signApplication = async ({ applicationId, data }: SignApplicationRequest) => {
  return await adminAxios.post(`wizard/applications/${applicationId}/sign`, data);
};

export { signApplication };
